"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BulkIndexContractServiceFee = class BulkIndexContractServiceFee extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "BulkIndexContractServiceFee.item");
    }
    items;
    onItems(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("items");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    labelAlign;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    item;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['labelAlign', 'formId', 'formName', 'item', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                formId: null,
                formName: "BulkIndexContractServiceFee",
                item: {
                    percentage: null,
                    new_indexation_date: null,
                    valid_from: null,
                    transaction_notes: null,
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("BulkIndexContractServiceFee|Title", "Indexing"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_8732_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_8738_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_request_8736_getActionArgs($event) {
        return {
            operation: "bulk_index_contract_service_fee",
            data: {
                items: _.map(this.items, p => _.extend(_.pick(p, ['id', 'etag']), { value: this.item }))
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_8732 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_8732_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_8731 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_8732,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_8731],
        });
        const act_2248226175642056_closeComponent_8734 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_8733 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_8734,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_8733],
        });
        const act_1040167445267876_closeModal_8738 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_8738_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_8737 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_8738,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_8736 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_8736_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_8737],
        });
        const evh_1040167445267876_submit_8735 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_8736,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_8735],
        });
        const act_1419464017721962_closeComponent_8740 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_8739 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_8740,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_8739],
        });
        return {
            act_7315092382398562_closeModal_8732,
            evh_7315092382398562_close_8731,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_8734,
            evh_2248226175642056_close_8733,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_8738,
            evh_1040167445267876_success_8737,
            act_1040167445267876_request_8736,
            evh_1040167445267876_submit_8735,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_8740,
            evh_1419464017721962_clickPreventStop_8739,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_8736,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], BulkIndexContractServiceFee.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BulkIndexContractServiceFee.prototype, "onItems", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], BulkIndexContractServiceFee.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BulkIndexContractServiceFee.prototype, "onSize", null);
BulkIndexContractServiceFee = __decorate([
    (0, vue_property_decorator_1.Component)()
], BulkIndexContractServiceFee);
exports.default = BulkIndexContractServiceFee;
vue_property_decorator_1.Vue.component("BulkIndexContractServiceFee", BulkIndexContractServiceFee);
